function MockedDecorator() {
  return function () {};
}

module.exports = new Proxy({}, {
  get: function() { return MockedDecorator; }
});
